module.exports = __webpack_public_path__ + "static/media/myJam-table.b41eb4a7.png";